import { useState, useEffect } from "react";
import ClientService from "../../services/resource/clientService";
import DropDown from "../../components/dropdown/dropdown";
import InputForm from "../../components/input/input";
import ButtonLoading from "../../components/buttonLoading/buttonLoading";
import InputFormMask from "../../components/inputMask/inputMask";

const initialValues = {
  id: '',
  code: '',
  name: '',
  addressStreet: '',
  addressNeighborhood: '',
  addressCity: '',
  addressUf: '',
  branchId: '',
  fantasyName: '',
  phone1: '',
  phone2: '',
};

function ClientUpdate({ client, branches, setShowModal, onChange }) {
  const [form, setForm] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadClient = async () => {

      const code = client.code.toString().substring(4, 12);
      setForm({
        id: client.id,
        code: code,
        name: client.name || '',
        addressStreet: client.addressStreet || '',
        addressNeighborhood: client.addressNeighborhood || '',
        addressCity: client.addressCity || '',
        addressUf: client.addressUf || '',
        branchId: client.branchId || '',
        fantasyName: client.fantasyName || '',
        phone1: client.phone1 || '',
        phone2: client.phone2 || '',
      })
      
    }
    loadClient();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await new ClientService().update(client.id, form);
      setShowModal(false);
      onChange();
    } catch (err) {
      setError(err.response?.data?.message || "Erro ao atualizar cliente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <DropDown
          id="cadastroBranchId"
          label="Filial"
          label1="name"
          optionValue="id"
          optionLabel="name"
          name="branchId"
          disabled={loading}
          value={form.branchId}
          options={branches}
          onChange={handleChange}
        />
        <div>
          <InputFormMask
            type="text"
            name="code"
            mask="9999-9999"
            placeholder="Digite o código do cliente..."
            value={form.code}
            onChange={handleChange}
            label="Código do Cliente"
          />
        </div>
        <div>
          <InputForm
            type="text"
            name="name"
            placeholder="Digite a razão social..."
            value={form.name}
            label="Razão Social"
            onChange={handleChange}
          />
        </div>
        <div>
          <InputForm
            type="text"
            name="fantasyName"
            placeholder="Digite o nome fantasia..."
            value={form.fantasyName}
            label="Nome Fantasia"
            onChange={handleChange}
          />
        </div>
        <div>
          <InputFormMask
            type="text"
            name="phone1"
            placeholder="Digite o telefone 1..."
            optional
            value={form.phone1}
            onChange={handleChange}
            label="Telefone 1"
            mask="99 99999-9999"
          />
        </div>
        <div>
          <InputFormMask
            type="text"
            name="phone2"
            placeholder="Digite o telefone 2..."
            optional
            value={form.phone2}
            onChange={handleChange}
            label="Telefone 2"
            mask="99 99999-9999"
          />
        </div>
        <div>
          <InputForm
            type="text"
            name="addressStreet"
            placeholder="Digite a rua..."
            optional
            value={form.addressStreet}
            onChange={handleChange}
            label="Rua" />
        </div>
        <div>
          <InputForm
            type="text"
            name="addressNeighborhood"
            label="Bairro"
            optional
            placeholder="Digite o bairro..."
            value={form.addressNeighborhood}
            onChange={handleChange}
            className="border p-2 rounded"
          />
        </div>
        <div>
          <InputForm
            type="text"
            name="addressCity"
            label="Cidade"
            optional
            placeholder="Digite a cidade..."
            value={form.addressCity}
            onChange={handleChange}
          />
        </div>
        <div>
          <InputForm
            type="text"
            name="addressUf"
            placeholder="Digite a UF..."
            optional
            value={form.addressUf}
            onChange={handleChange}
            label="UF"
            maxLength={2}
          />
        </div>
      </div>

      {error && <p className="text-red-600 mt-2">{error}</p>}
      <div className="flex justify-end space-x-3 mt-4">
        <ButtonLoading
          id="cancel-update"
          type="text"
          color="gray"
          label="Cancelar"
          optional
          onClick={() => setShowModal(false)}
        />
        <ButtonLoading
          type="submit"
          label="Atualizar Cliente"
          color="blue"
          id="confirm-update"
          loading={loading}
        />
      </div>
    </form>
  );
}

export default ClientUpdate;
